export default {"src":"/_next/static/media/vertical.21210dcc.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};